module.exports = __webpack_public_path__ + "img/Success.74e7eea3.svg";